import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './ConfirmArrival.css';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function ConfirmArrival() {
    const query = useQuery();
    const bookingId = query.get('bookingId');
    const token = query.get('token');
    const [status, setStatus] = useState('pending'); // pending, success, error
    const [message, setMessage] = useState('Please wait while we confirm your booking...');
    const navigate = useNavigate();

    useEffect(() => {
        if (!bookingId || !token) {
            setStatus('error');
            setMessage('Missing bookingId or token in the link.');
            return;
        }

        (async () => {
            try {
                // Use native fetch instead of axios to avoid any auth interceptors
                // Token is passed in URL - no login needed
                const response = await fetch(
                    `/api/bookings/${bookingId}/arrival-confirm?token=${encodeURIComponent(token)}`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                const data = await response.json();

                if (response.ok && data.success) {
                    setStatus('success');
                    setMessage(data.message || 'Arrival confirmed — enjoy your day at the office!');
                } else {
                    setStatus('error');
                    setMessage(data.error || 'Unable to confirm arrival');
                }
            } catch (err) {
                setStatus('error');
                setMessage(err.message || 'Confirmation failed');
            }
        })();
    }, [bookingId, token]);

    return (
        <div className="confirm-arrival-page" style={{ backgroundImage: `url(/thankyou.jpg?v=${new Date().getTime()})` }}>
            <div className="card">
                <h2>Arrival confirmation</h2>
                {status === 'pending' && <div className="status pending">{message}</div>}
                {status === 'success' && <div className="status success">{message}</div>}
                {status === 'error' && <div className="status error">{message}</div>}

                <div className="actions">
                    <button onClick={() => navigate('/')}>Your Arrival is Confirmed !</button>
                </div>
            </div>
        </div>
    );
}
